import { Text } from '@ad-lucy/ui';
import { Component, type ReactNode } from 'react';
import styled from 'styled-components';

const ErrorText = styled(Text)`
  color: ${({ theme }) => theme?.colors?.error._400};
`;

type ErrorBoundaryProps = { fallback?: ReactNode; children: ReactNode };

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  { hasError: boolean }
> {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: unknown, errorInfo: unknown) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || <ErrorText>Something went wrong</ErrorText>;
    }

    return this.props.children;
  }
}
